import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: FadeInProps) {
  const offsets = {
    up: {
      y: 24,
      x: 0
    },
    down: {
      y: -24,
      x: 0
    },
    left: {
      x: 24,
      y: 0
    },
    right: {
      x: -24,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...offsets[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.25, 0.46, 0.45, 0.94]
  }} className={className} data-id="element-202">
      {children}
    </motion.div>;
}